import React, { Component } from "react";
import { Card, CardHeader, CardBody, UncontrolledAlert } from "reactstrap";
import DataTable from "../../Shared/DataTable";
import Moment from "moment";
import { ApprovedContents } from "../../../_constants/RouteVariables";
import { MdSearch } from "react-icons/md";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { tourMessages } from "../../../_constants/tutorialmessages/ManualMessages";
export class AdminDashBoardTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      run: false,
      stepIndex: 0,
      steps: [
        {
          target: tourMessages.adminPendingTables.target,
          content: (
            <div>
              <p>{tourMessages.adminPendingTables.content}</p>
            </div>
          ),
          placement: "left",
          locale: { skip: "SKIP", close: "Next" }
        },
        tourMessages.default
      ]
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.showNextJoyRide) {
      this.setState({ run: true });
      this.props.setNextJoyRide();
    }
  }
  handleJoyrideCallback = data => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.CANCEL, STATUS.CANCEL].includes(status)) {
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if ([STATUS.SKIPPED].includes(status)) {
        this.setState({ run: false });
      } else {
        this.props.routeChange();
      }
    }
  };
  render() {
    const columns = [
      {
        Header: "Interest",
        accessor: "interestName",
        maxWidth: 400
      },
      {
        Header: "Instructor",
        accessor: "instructorName"
      },
      {
        Header: "Title",
        accessor: "title"
      },

      {
        Header: "Date",
        id: "submittedOn",
        accessor: d => {
          return Moment(d.submittedOn)
            .local()
            .format("DD-MM-YYYY ");
        }
      }
    ];

    const {
      match,
      fetching,
      data,
      error,
      selectRow,
      deleteInterest,
      showModal,
      pages,
      page,
      pageSize,
      setPageNumber,
      filterData,
      setPageSize
    } = this.props;
    const { run, steps, stepIndex } = this.state;
    const actions = [
      {
        name: "view",
        btnText: "View",
        isLink: true,
        to: ApprovedContents,
        btnAction: selectRow,
        btnClass: "btn-success",
        btnIcon: MdSearch
      }
    ];

    return (
      <div>
        <Joyride
          steps={steps}
          scrollToFirstStep
          showProgress
          showSkipButton
          styles={{
            options: {
              width: 200,
              height: 60,
              zIndex: 1000
            }
          }}
          callback={this.handleJoyrideCallback}
          run={run}
          stepIndex={stepIndex}
        />

        <Card>
          <CardHeader>Pending Contents</CardHeader>
          <CardBody className="joyride2">
            {error && (
              <UncontrolledAlert color="danger">
                {error.message}
              </UncontrolledAlert>
            )}

            <DataTable
              columns={columns}
              loading={fetching}
              urlParams={match}
              data={data ? data.content : []}
              count={data ? data.count : 0}
              defaultPageSize={5}
              deleteRow={deleteInterest}
              selectRow={selectRow}
              showModal={showModal}
              manual={true}
              pages={pages}
              page={page}
              pageSize={pageSize}
              showInstructorActions={false}
              filterData={filterData}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              searchParam="searchKey"
              searchPlaceholder="Search by title/instructor"
              isView={true}
              isAdmin={true}
              actions={actions}
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default AdminDashBoardTable;
